/**
 * Don't use import/export so this can run in node native
 */

// Vee-Validate Library
const veevalidate = require('vee-validate');

// Custom Validation Rules
const veeCustomRules = require('./vee-custom-rules');

veeCustomRules();
module.exports = { veevalidate };
